import { DateTime } from 'luxon';
import { useMemo } from 'react';
import { yesterdayString } from '@/features/common/date.lib';
import type { PageExperienceFragment } from '@/features/experiences/fragments/PageExperience.generated';
import {
  EventListDisplay,
  type ListExperienceEventInput,
} from '@/types/gql.generated';

type Arg = {
  experience: PageExperienceFragment | undefined;
};

const toDateOnly = (
  isoString: string | null | undefined
): string | undefined => {
  if (!isoString) return undefined;
  return DateTime.fromISO(isoString, { zone: 'utc' }).toISODate() ?? undefined;
};

export const useEventListFilters = ({
  experience,
}: Arg): ListExperienceEventInput => {
  return useMemo(() => {
    return {
      startDate:
        toDateOnly(experience?.eventListStartDate) ??
        (experience?.eventListDisplay === EventListDisplay.Upcoming
          ? yesterdayString()
          : undefined),
      endDate: toDateOnly(experience?.eventListEndDate),
    };
  }, [
    experience?.eventListStartDate,
    experience?.eventListEndDate,
    experience?.eventListDisplay,
  ]);
};
